import { Plugin } from 'ckeditor5/src/core';
import MgnlNoteUI from './mgnlnoteui';
import MgnlNoteEditing from './mgnlnoteediting';

/**
 * The Magnolia note plugin.
 *
 * It provides styled note blocks with different visual styles for
 * different types of information (sample, tip, danger, important, etc.).
 */
export default class MgnlNote extends Plugin {
	/**
	 * @inheritDoc
	 */
	public static get pluginName() {
		return 'MgnlNote' as const;
	}

	/**
	 * @inheritDoc
	 */
	public static get requires() {
		return [MgnlNoteEditing, MgnlNoteUI] as const;
	}
}
